// removed by extract-text-webpack-plugin
module.exports = {"default":"_2g-eX","focusable":"_1m5wJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VisuallyHidden/VisuallyHidden.scss
// module id = 1878
// module chunks = 0